/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import TargetingContent from 'shared/ui/components/form-components/targeting/TargetingContent.vue';

/**
 * Component to create and edit targeting.
 *
 * @example
 * ```
 * targeting-control(name="foo" v-model="trg" label="Targeting" :event-id="event._id")
 * ```
 *
 * It has all `BaseControl` options plus:
 *
 * @vue-prop {String} eventId the ID of the event
 *
 * @category shared.ui.components.form-controls
 * @exports TargetingControl
 * @component
 */
const __vue_script__ = {
    name: 'TargetingControl',

    components: { Badge, ExpandableContent, TargetingContent },

    extends: BaseControl,

    props: {
        eventId: {
            type: String,
            required: true
        },

        value: {
            type: Object,
            default() {
                return {
                    targets: null,
                    exceptions: null
                };
            }
        },

        slim: {
            type: Boolean,
            default: false
        },

        visibleToLabel: {
            type: String,
            default: null
        },

        hiddenToLabel: {
            type: String,
            default: null
        },

        visibleToDesc: {
            type: String,
            default: null
        },

        hiddenToDesc: {
            type: String,
            default: null
        },

        targetLabel: {
            type: String,
            default: null
        },

        expandable: {
            type: Boolean,
            default: true
        },

        additionalFields: {
            type: Array,
            default: () => [],
        },

        appearance: {
            type: String,
            default: null
        },

        fieldValuesToRemove: {
            type: Object,
            default: () => {}
        },

        showTargets: {
            type: Boolean,
            default: true
        },

        showExceptions: {
            type: Boolean,
            default: true
        },

        showAffectedPaxBtn: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        /** @returns {boolean} */
        hasRules() {
            return Boolean(this.value?.targets?.length || this.value?.exceptions?.length);
        },

        internalValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', {
                    targets: value?.targets?.length ? value.targets : null,
                    exceptions: value?.exceptions?.length ? value.exceptions : null,
                });
            }
        },

        expanded() {
            return this.expandable && (this.hasRules || this.manualOpen);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "targeting-control",
      attrs: {
        uid: _vm.uid,
        errors: _vm.errors,
        warning: _vm.warning,
        dependant: _vm.dependant,
      },
    },
    [
      _vm.expandable
        ? _c("expandable-content", {
            ref: "main",
            staticClass: "form-control",
            attrs: {
              focused: _vm.focused,
              "unlimited-height": true,
              "clickable-header": true,
              slim: _vm.slim,
              tabindex: "0",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function (ref) {
                    return [
                      _c(
                        "label",
                        [
                          _c("span", [_vm._v(_vm._s(_vm.label))]),
                          _vm.tip
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.right",
                                    value: _vm.tip,
                                    expression: "tip",
                                    modifiers: { right: true },
                                  },
                                ],
                                staticClass: "tip ic-info",
                              })
                            : _vm._e(),
                          _vm.hasRules
                            ? _c(
                                "badge",
                                {
                                  staticClass: "info",
                                  attrs: { "stop-click": false },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "targeting.conditions_editor.applied"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _c("badge", { attrs: { "stop-click": false } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.targetLabel ||
                                      _vm.$t(
                                        "targeting.conditions_editor.visible_to_everyone"
                                      )
                                  )
                                ),
                              ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "default",
                  fn: function (ref) {
                    return [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.hint ||
                              _vm.$t("targeting.conditions_editor.intro")
                          )
                        ),
                      ]),
                      _c("targeting-content", {
                        attrs: {
                          "event-id": _vm.eventId,
                          "visible-to-label": _vm.visibleToLabel,
                          "hidden-to-label": _vm.hiddenToLabel,
                          "visible-to-desc": _vm.visibleToDesc,
                          "hidden-to-desc": _vm.hiddenToDesc,
                          "additional-fields": _vm.additionalFields,
                          "field-values-to-remove": _vm.fieldValuesToRemove,
                          "show-targets": _vm.showTargets,
                          "show-exceptions": _vm.showExceptions,
                          "show-affected-pax-btn": _vm.showAffectedPaxBtn,
                        },
                        model: {
                          value: _vm.internalValue,
                          callback: function ($$v) {
                            _vm.internalValue = $$v
                          },
                          expression: "internalValue",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              3702610662
            ),
          })
        : _c("targeting-content", {
            attrs: {
              "event-id": _vm.eventId,
              "visible-to-label": _vm.visibleToLabel,
              "hidden-to-label": _vm.hiddenToLabel,
              "visible-to-desc": _vm.visibleToDesc,
              "hidden-to-desc": _vm.hiddenToDesc,
              "additional-fields": _vm.additionalFields,
              "field-values-to-remove": _vm.fieldValuesToRemove,
              "show-targets": _vm.showTargets,
              "show-exceptions": _vm.showExceptions,
              "show-affected-pax-btn": _vm.showAffectedPaxBtn,
            },
            model: {
              value: _vm.internalValue,
              callback: function ($$v) {
                _vm.internalValue = $$v
              },
              expression: "internalValue",
            },
          }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/TargetingControl.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__